// Navigation constants to avoid hardcoded strings
export const SCREEN_TITLES = {
  // Dashboard
  DATA_MIGRATION: 'admin.dataMigration',
  
  // Profile
  TEAM_MANAGEMENT: 'profile.teamManagement',
  ADD_MEMBER: 'profile.addMember',
  PRIVACY_POLICY: 'legal.privacyPolicy',
  TERMS_OF_SERVICE: 'legal.termsOfService',
  
  // Inventory
  REORDER_MANAGEMENT: 'inventory.reorderManagement',
  
  // Common
  ACCEPT_INVITATION: 'auth.acceptInvitation',
} as const;

// Tab icon mapping
export const TAB_ICONS = {
  Dashboard: 'dashboard',
  Purchases: 'shopping-cart',
  Vendors: 'building-o',
  Inventory: 'cube',
  Profile: 'user-o',
} as const;

// Screen names constants
export const SCREEN_NAMES = {
  // Auth
  AUTH_NAVIGATOR: 'AuthNavigator',
  LOGIN: 'Login',
  REGISTER: 'Register',
  FORGOT_PASSWORD: 'ForgotPassword',
  ACCEPT_INVITATION: 'AcceptInvitation',
  ORGANIZATION_ONBOARDING: 'OrganizationOnboarding',
  
  // Main
  TAB_NAVIGATOR: 'TabNavigator',
  LOADING: 'Loading',
  
  // Dashboard
  DASHBOARD_HOME: 'DashboardHome',
  DATA_MIGRATION: 'DataMigration',
  AI_INSIGHTS: 'AIInsights',
  NOTIFICATION_CENTER: 'NotificationCenter',
  EXPORT_INVOICES: 'ExportInvoices',
  
  // Tabs
  DASHBOARD: 'Dashboard',
  PURCHASES: 'Purchases',
  VENDORS: 'Vendors',
  INVENTORY: 'Inventory',
  PROFILE: 'Profile',
  
  // Stack
  PROFILE_STACK: 'ProfileStack',
} as const;